export default "__VITE_ASSET__C4Yo3nlf__"